'use client'
import { Dispatch, ReactNode, SetStateAction } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import THREEJSConfig from './engine-conf/threejs.tsx';
import WGPUConfig from './engine-conf/wgpu.tsx';

type EngineConfigProp = {
setSelectedConf: Dispatch<SetStateAction<number>>
}

const EngineConfig = (props: EngineConfigProp):ReactNode =>{
    
    const lst = localStorage.getItem('engine');
    const activeKey = lst == null || parseInt(lst) == 0 ? 'threejs' : 'wgpu';
            
    return (
      <div className='container'>
        <div className='text-right'><button onClick={()=> props.setSelectedConf(0)}>x</button></div>
        <Tabs  onSelect={(k) => localStorage.setItem('engine', k === 'wgpu' ? "2" : "0")} defaultActiveKey={activeKey} id="engine-list-tabs">
            <Tab eventKey="threejs" title="threejs"><THREEJSConfig  /></Tab>
            <Tab eventKey="wgpu" title="webgpu"><WGPUConfig  /></Tab>
        </Tabs>
        </div>
    );
}
export default EngineConfig;
        